import ApiService from '../../../../../../services/ApiService'
import moment from 'moment'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      downtimes: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      downtimeHeader: [
        {
          text: 'Instituição',
          align: 'center',
          value: 'institution',
          width: '140px',
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unidadeName',
          width: '130px',
        },
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'standardEquipment',
          width: '160px',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
          width: '130px',
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'manufacturer',
          width: '130px',
        },
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrderNumber',
          width: '100px',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
          width: '120px',
        },
        {
          text: 'Data de Parada',
          align: 'center',
          value: 'stopDate',
          width: '150px',
        },
        {
          text: 'Data de Retorno',
          align: 'center',
          value: 'returnDate',
          width: '150px',
        },
        {
          text: 'Tempo Parado (Expediente)',
          align: 'center',
          value: 'duringWorkDowntime',
          width: '180px',
        },
        {
          text: 'Disponibilidade',
          align: 'center',
          value: 'availability',
          width: '130px',
        },
      ],
      downtimeMobileHeader: [
        {
          text: 'Instituição',
          align: 'center',
          value: 'institution',
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unit',
        },
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'standardEquipment',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listDowntimes()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Equipment_Dowmtime_Institution_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('bigdata/equipmentDowntimeWithInstitutionExcel', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listDowntimes() {
      await this.apiService
        .post('bigdata/equipmentDowntimeWithInstitution', this.filterProp)
        .then((response) => {
          this.showChart = response.content.objects.length > 0
          this.downtimes = response.content.objects
          this.totalPages = response.content.pager.totalPages
          this.total = response.content.pager.totalItems
        })
    },

    formatDate(date) {
      if (!date) return ''
      const m = moment(date, ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD/MM/YYYY'])
      return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : date
    },

    formatAvailability(value) {
      if (value === null || value === undefined) return '-'
      const num = parseFloat(value)
      if (isNaN(num)) return '-'
      return `${num.toFixed(2).replace('.', ',')}%`
    },

    formatDowntime(value) {
      if (!value) return '00H00m'
      const parts = value.split(':')
      const hours = String(parseInt(parts[0], 10)).padStart(2, '0')
      const minutes = String(parseInt(parts[1], 10)).padStart(2, '0')
      return `${hours}H${minutes}m`
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listDowntimes()
    },
  },
}
